import { render, staticRenderFns } from "./MVPMedia.vue?vue&type=template&id=2b76e3dc"
import script from "./MVPMedia.vue?vue&type=script&lang=js"
export * from "./MVPMedia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports